export default __webpack_public_path__ + "static/media/traveloka-illustration-transparent.70cf84fa.png";